// Simple rate limiting replacement - no database, just memory
const rateLimitMap = new Map<string, { count: number; windowStart: number }>();

export const useSimpleRateLimit = () => {
  const checkRateLimit = async (config: { action: string; maxRequests: number; windowMinutes: number }): Promise<boolean> => {
    const windowMs = config.windowMinutes * 60 * 1000;
    const now = Date.now();
    const key = config.action;
    
    const existing = rateLimitMap.get(key);
    
    if (!existing || (now - existing.windowStart) > windowMs) {
      rateLimitMap.set(key, { count: 1, windowStart: now });
      return true;
    }
    
    if (existing.count >= config.maxRequests) {
      console.warn(`Rate limit exceeded for ${config.action}`);
      return false;
    }
    
    existing.count++;
    return true;
  };

  return {
    checkRateLimit
  };
};